var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2590)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55469 36.7773C8.71094 36.6016 8.90625 36.4648 9.12109 36.3672C9.33594 36.2695 9.57031 36.2109 9.80469 36.2109H49.082C49.2578 36.2109 49.4141 36.2695 49.5508 36.3477C49.6875 36.4453 49.8047 36.5625 49.8633 36.7188C49.9219 36.875 49.9414 37.0312 49.9219 37.207C49.9023 37.3633 49.8242 37.5195 49.707 37.6367L41.3867 46.875C41.2305 47.0508 41.0352 47.1875 40.8203 47.2852C40.6055 47.3828 40.3711 47.4414 40.1367 47.4414H0.820312C0.644531 47.4414 0.488281 47.3828 0.351562 47.3047C0.214844 47.207 0.0976562 47.0898 0.0390625 46.9336C-0.0195313 46.7773 -0.0390625 46.6211 -0.0195312 46.4453C0 46.2891 0.078125 46.1328 0.195312 46.0156L8.55469 36.7773ZM49.7266 29.1211C49.8438 29.2383 49.9219 29.3945 49.9414 29.5508C49.9609 29.707 49.9414 29.8828 49.8828 30.0391C49.8242 30.1953 49.707 30.3125 49.5703 30.4102C49.4336 30.5078 49.2773 30.5469 49.1016 30.5469L9.82422 30.5859C9.58984 30.5859 9.35547 30.5273 9.14062 30.4297C8.92578 30.332 8.73047 30.1953 8.57422 30.0195L0.175781 20.8203C0.0585937 20.7031 -0.0195312 20.5469 -0.0390625 20.3906C-0.0585938 20.2344 -0.0390625 20.0586 0.0195312 19.9023C0.078125 19.7461 0.195312 19.6289 0.332031 19.5312C0.46875 19.4336 0.625 19.3945 0.800781 19.3945L40.0977 19.3359C40.332 19.3359 40.5664 19.3945 40.7812 19.4922C40.9961 19.5898 41.1914 19.7266 41.3477 19.9023L49.7266 29.1211ZM8.55469 3.02734C8.71094 2.85156 8.90625 2.71484 9.12109 2.61719C9.33594 2.51953 9.57031 2.46094 9.80469 2.46094L49.1016 2.5C49.2578 2.5 49.4336 2.55859 49.5703 2.63672C49.707 2.73437 49.8242 2.85156 49.8828 3.00781C49.9414 3.16406 49.9609 3.32031 49.9414 3.49609C49.9219 3.65234 49.8438 3.80859 49.7266 3.92578L41.3672 13.1445C41.2109 13.3203 41.0156 13.457 40.8008 13.5547C40.5859 13.6523 40.3516 13.7109 40.1172 13.7109H0.820312C0.644531 13.7109 0.488281 13.6523 0.351562 13.5742C0.214844 13.4766 0.0976562 13.3594 0.0390625 13.2031C-0.0195313 13.0469 -0.0390625 12.8906 -0.0195312 12.7148C0 12.5391 0.078125 12.3828 0.195312 12.2656L8.55469 3.02734Z",
    fill: "url(#paint0_linear_2460_2590)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2590",
    x1: 1.46621,
    y1: 48.4525,
    x2: 48.4328,
    y2: 1.48613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8A53F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6377D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#24B0A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00D18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D18C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg41);
export default __webpack_public_path__ + "static/media/41.16c3d3d35c2bba7d609775c4272902bd.svg";
export { ForwardRef as ReactComponent };